import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UIError} from './uierror';
import {of as observableOf} from 'rxjs';
import {catchError, switchMap, take} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {LayoutService} from '../layout/layout.service';
import {Endpoint} from '../layout/endpoint';

@Injectable()
export class ErrorService {
  constructor(
    private http: HttpClient,
    private layoutService: LayoutService,
  ) {}

  reportError(error: UIError) {
    try {
      let headers = new HttpHeaders({'Content-Type': 'application/json'});
      this.layoutService.endpoint$
        .pipe(
          take(1),
          switchMap((env: Endpoint) => {
            if (env.isCloud()) {
              let clouderror: any = {};
              clouderror.displayname = error.DisplayName;
              clouderror.code = error.UIErrorCode;
              clouderror.message = error.UIErrorMessage;
              clouderror.scope = error.UIErrorScope;
              clouderror.useragent = error.UIErrorUserAgent;
              clouderror.objecttype = error.ObjectType.toLowerCase();
              return this.http.post(env.getUrl() + 'v2/resources/', JSON.stringify(clouderror), {
                headers: headers,
                ...(!env.isCloud() ? {withCredentials: true} : {}),
              });
            } else {
              return this.http.post(env.getUrl() + 'v2/resources/', JSON.stringify(error), {
                headers: headers,
                ...(!env.isCloud() ? {withCredentials: true} : {}),
              });
            }
          }),
          catchError(() => observableOf(null)),
        )
        .subscribe();
    } catch (error) {
      //we have to catch these errors, otherwise an infinite loop is created
      console.warn('Could not report error to MIM Service!');
      console.warn(error);
    }
  }
}
